import {React}  from 'react';
import {FaYelp, FaEnvelope} from 'react-icons/fa';

const Footer = () => {
    return (
      <footer className="text-white py-4 bg-blue-500" >
        <div className="container mx-auto px-4 flex justify-between items-center">
          <div>
            <p>Copyright &copy; 2024 Stud TV Installs - All Rights Reserved - (425) 495-9981</p>
          </div>
          <div className="flex space-x-4">
            <a href="mailto:studtvinstalls@gmail.com" className="hover:text-gray-800">
              <FaEnvelope size={21}/>
            </a>
            <a href="https://www.yelp.com/biz/stud-tv-installs-seatac" className="hover:text-gray-800">
              <FaYelp size={21}/>
            </a>
          </div>
        </div>
      </footer>
    );
};

export default Footer;
